import { v4 as createUUID } from "uuid"

interface CreateSliceKeyArgs {
  sliceId: string
  uuid?: string
}

export function createSliceKey(args: CreateSliceKeyArgs) {
  const { sliceId, uuid = createUUID() } = args
  return `${sliceId}$${uuid}`
}
